document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gifting-quiz]').forEach((quiz) => {
    const firstStepId = quiz.dataset.firstStep;
    const history = [];

    const hideAll = () => {
      quiz.querySelectorAll('[data-quiz-step], [data-quiz-result]').forEach((el) => {
        el.classList.add('gifting-quiz__card--hidden');
      });
    };

    const showTarget = (targetId) => {
      hideAll();
      const target =
        quiz.querySelector(`[data-quiz-step="${targetId}"]`) ||
        quiz.querySelector(`[data-quiz-result="${targetId}"]`);
      if (target) {
        target.classList.remove('gifting-quiz__card--hidden');
      }
    };

    const goTo = (targetId, fromId) => {
      if (fromId) history.push(fromId);
      showTarget(targetId);
    };

    const goBack = () => {
      const prevId = history.pop();
      if (prevId) {
        showTarget(prevId);
        const prevStep = quiz.querySelector(`[data-quiz-step="${prevId}"]`);
        if (prevStep) {
          prevStep.querySelectorAll('[data-quiz-option]').forEach((opt) => {
            opt.classList.remove('gifting-quiz__option--selected');
          });
        }
      }
    };

    const restart = () => {
      history.length = 0;
      quiz.querySelectorAll('[data-quiz-option]').forEach((opt) => {
        opt.classList.remove('gifting-quiz__option--selected');
      });
      showTarget(firstStepId);
    };

    quiz.addEventListener('click', (e) => {
      const option = e.target.closest('[data-quiz-option]');
      if (option) {
        const step = option.closest('[data-quiz-step]');
        if (!step) return;

        step.querySelectorAll('[data-quiz-option]').forEach((opt) => {
          opt.classList.remove('gifting-quiz__option--selected');
        });
        option.classList.add('gifting-quiz__option--selected');

        const targetId = option.dataset.target;
        if (!targetId) return;

        const currentStepId = step.dataset.quizStep;

        setTimeout(() => {
          goTo(targetId, currentStepId);
        }, 300);
        return;
      }

      if (e.target.closest('[data-quiz-back]')) {
        goBack();
        return;
      }

      if (e.target.closest('[data-quiz-restart]')) {
        restart();
      }
    });
  });
});
